import { Text, View, Image } from "@react-pdf/renderer";
import { globalStyles } from "config/pdfStyles";
import { dateFormat } from "helpers/common";
import FrequencyTrack from "Assets/images/frequency_trach_bar.png"
import FrequencyTracker from "Assets/images/track_bar_tracker.png"

const AnswerTracker = ({ answer, question }) => {
  const answerOtherDetails = answer?.answer?.other_details;
  return (
    <>
      {answerOtherDetails?.tracking?.length > 0 && answerOtherDetails?.tracking?.map((answerData, index) => {
        return (
          <View style={[globalStyles.standardBorder, { borderRadius: "5px", padding: "10px", marginTop: "10px" }]}>
            <Text style={globalStyles.tableHead}>{dateFormat(answerData?.date_time, "DD-MM-YYYY hh:mm A")}</Text>
            <View style={{ marginTop: "10px" }}>
              <Text style={globalStyles.tableHead}>Observations</Text>
              {answerData.notes && (
                <Text style={{ marginTop: "10px" }}>{answerData.notes}</Text>
              )}
            </View>
            <View style={{ width: "50%" }}>
              <Image
                style={{ marginTop: "10px", width: "100%" }}
                src={FrequencyTrack}
              />
              <Image
                style={{ marginTop: "-30px", width: "20px", marginLeft: `${answerData?.percentage}%` }}
                src={FrequencyTracker}
              />
              <Text style={{ textAlign:"center" }}>{answerData?.percentage} %</Text>
            </View>
          </View>
        )
      })}
    </>
  )
}

export default AnswerTracker;